<template>
    <div class="banner-container">
    </div>
</template>

<script>
    export default {
        name: "ArticleBanner",
    }
</script>

<style scoped>

    .banner-container {
        width: 100%;
        height: 240pt;

        background-size: cover;
        background-position: center;
    }

</style>